<template>
  <b-modal
    :id="id"
    :title="trans('grade_choices')"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <p>
      {{ trans('grade_choices_instructions') }}
    </p>
    <b-form-group>
      <b-form-tags
        tag-variant="success"
        remove-on-delete
        v-model="choices"
        :placeholder="trans('grades')"
        :add-button-text="trans('add')"
      ></b-form-tags>
    </b-form-group>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'grade-choices-modal',
      },
      organization: Object,
      value: Array,
    },
    data() {
      return {
        trans: trans,
        choices: null,
      }
    },
    methods: {
      onShown() {
        this.choices = this.value ? _.compact(this.value) : null
      },
      onSave() {
        this.$emit('input', this.choices ? _.compact(this.choices) : null)
      },
    },
    mounted() {
      window.gradeChoicesModal = this
    },
  }
</script>